import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry(): void {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,

    // Capture 100% of errors, sample 10% of transactions for performance
    tracesSampleRate: Number.parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1'),

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Mask all text and block all media by default for privacy
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Capture 10% of sessions for replay, 100% on error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

export { Sentry };
